import classnames from 'classnames'
import { PropsWithChildren } from 'react'

export enum KeyStatsVariant {
  Compact,
  Stretched,
}

type KeyStatsProps = {
  className?: string
  variant?: KeyStatsVariant
}

export function KeyStats({ children, className, variant = KeyStatsVariant.Compact }: PropsWithChildren<KeyStatsProps>) {
  return (
    <div
      className={classnames(className, 'flex gap-16', {
        'justify-center': variant === KeyStatsVariant.Compact,
        'justify-between': variant === KeyStatsVariant.Stretched,
      })}
    >
      {children}
    </div>
  )
}
